const STORAGE_KEY = 'wergame_referral_code';

export function normalizeReferralCode(raw) {
  return String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}

export function captureReferralFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref') || params.get('referral');
    const code = normalizeReferralCode(ref);
    if (code) {
      localStorage.setItem(STORAGE_KEY, code);
    }
  } catch {
    // ignore
  }
}

export function getStoredReferralCode() {
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function clearStoredReferralCode() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
